"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M19.59 7 12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"
}), 'CallMissed');